import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Type } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

const MeetNerdsTile = ({
  employeeImageUrl,
  employeeName,
  employeeTitle,
  employeeDescription,
  employeeImageUrl1,
  employeeName1,
  employeeTitle1,
  employeeDescription1,
  employeeImageUrl2,
  employeeName2,
  employeeTitle2,
  employeeDescription2,
}) => (
  <div>
    <div
      className={classNames([
        'meet-nerds__tile',
        classes('display-none--wide'),
        classes('display-flex'),
        classes('flex-direction-column'),
      ])}
    >
      {employeeImageUrl && (
        <div>
          <Image
            src={employeeImageUrl}
            alt={employeeName}
            naturalHeight={550}
            naturalWidth={825}
            backgroundColor="transparent"
            imageClassName={classNames([
              'meet-nerds__image',
              classes('margin-bottom-3'),
            ])}
          />
        </div>
      )}
      <div
        className={classNames(['meet-nerd__inner', classes('text-align-left')])}
      >
        {employeeName && (
          <Type chronicle size="3" className={classNames(['meet-nerd__name'])}>
            {employeeName}
          </Type>
        )}
        {employeeTitle && (
          <Type
            default
            size="2"
            className={classNames([
              'meet-nerd__title',
              classes('margin-bottom-3'),
            ])}
          >
            {employeeTitle}
          </Type>
        )}
        {employeeDescription && (
          <Type default size="1" className={classNames(['meet-nerd__title'])}>
            {employeeDescription}
          </Type>
        )}
      </div>
    </div>
    <div
      className={classNames([
        'meet-nerds__tile-cont',
        classes('display-none'),
        classes('display-flex--wide'),
        classes('flex-direction-row'),
        classes('margin-bottom-4'),
      ])}
    >
      <div
        className={classNames([
          'meet-nerds__tile',
          classes('margin-right-4--wide'),
          classes('display-flex'),
          classes('flex-direction-column'),
        ])}
      >
        {employeeImageUrl1 && (
          <div>
            <Image
              src={employeeImageUrl1}
              alt={employeeName1}
              naturalHeight={550}
              naturalWidth={825}
              backgroundColor="transparent"
              imageClassName={classNames([
                'meet-nerds__image',
                classes('margin-bottom-3'),
              ])}
            />
          </div>
        )}
        <div
          className={classNames([
            'meet-nerd__inner',
            classes('text-align-left'),
          ])}
        >
          {employeeName1 && (
            <Type
              chronicle
              size="3"
              className={classNames(['meet-nerd__name'])}
            >
              {employeeName1}
            </Type>
          )}
          {employeeTitle1 && (
            <Type
              default
              size="2"
              className={classNames([
                'meet-nerd__title',
                classes('margin-bottom-3'),
              ])}
            >
              {employeeTitle1}
            </Type>
          )}
          {employeeDescription1 && (
            <Type default size="1" className={classNames(['meet-nerd__title'])}>
              {employeeDescription1}
            </Type>
          )}
        </div>
      </div>
      <div
        className={classNames([
          'meet-nerds__tile',
          classes('margin-right-0'),
          classes('display-flex'),
          classes('flex-direction-column'),
        ])}
      >
        {employeeImageUrl2 && (
          <div>
            <Image
              src={employeeImageUrl2}
              alt={employeeName2}
              naturalHeight={550}
              naturalWidth={825}
              backgroundColor="transparent"
              imageClassName={classNames([
                'meet-nerds__image',
                classes('margin-bottom-3'),
              ])}
            />
          </div>
        )}
        <div
          className={classNames([
            'meet-nerd__inner',
            classes('text-align-left'),
          ])}
        >
          {employeeName2 && (
            <Type
              chronicle
              size="3"
              className={classNames(['meet-nerd__name'])}
            >
              {employeeName2}
            </Type>
          )}
          {employeeTitle2 && (
            <Type
              default
              size="2"
              className={classNames([
                'meet-nerd__title',
                classes('margin-bottom-3'),
              ])}
            >
              {employeeTitle2}
            </Type>
          )}
          {employeeDescription2 && (
            <Type default size="1" className={classNames(['meet-nerd__title'])}>
              {employeeDescription2}
            </Type>
          )}
        </div>
      </div>
    </div>
  </div>
);

MeetNerdsTile.propTypes = {
  employeeImageUrl: PropTypes.string,
  employeeName: PropTypes.string,
  employeeTitle: PropTypes.string,
  employeeDescription: PropTypes.string,
  employeeImageUrl1: PropTypes.string,
  employeeName1: PropTypes.string,
  employeeTitle1: PropTypes.string,
  employeeDescription1: PropTypes.string,
  employeeImageUrl2: PropTypes.string,
  employeeName2: PropTypes.string,
  employeeTitle2: PropTypes.string,
  employeeDescription2: PropTypes.string,
};

MeetNerdsTile.displayName = 'Meet Nerds Tile';

export default MeetNerdsTile;
